import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePropertyMutationVariables = Types.Exact<{
  input: Types.CreatePropertyInput;
}>;


export type CreatePropertyMutation = { __typename?: 'mutation_root', create_property?: { __typename?: 'CreatePropertyOutput', success: boolean, property_id?: string | null, error?: string | null, created_property?: { __typename?: 'properties_ActionType', id: any, address?: string | null, name: string, photo_link?: string | null, premium?: boolean | null, tier_status?: string | null, warranty_document_id?: any | null, warranty_expiration_date?: any | null, warranty_start_date?: any | null, building_type?: string | null, occupancy_class?: string | null, num_stories?: number | null, num_units?: number | null, construction_type?: string | null, sprinklered?: string | null, year_built?: number | null, expected_device_type?: Array<string | null> | null, partition_id?: string | null, organization_id: any, workspace_id?: any | null, created_at?: any | null, updated_at?: any | null } | null } | null };


export const CreatePropertyDocument = gql`
    mutation createProperty($input: CreatePropertyInput!) {
  create_property(input: $input) {
    success
    property_id
    error
    created_property {
      id
      address
      name
      photo_link
      premium
      tier_status
      warranty_document_id
      warranty_expiration_date
      warranty_start_date
      building_type
      occupancy_class
      num_stories
      num_units
      construction_type
      sprinklered
      year_built
      expected_device_type
      partition_id
      organization_id
      workspace_id
      created_at
      updated_at
    }
  }
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, options);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;